<template>
  <div class="job-detail-profile-card">
    <v-card raised class="job-profile-shell">
      <loading :active.sync="loading" />
      <v-card-title class="bg-clr job-profile-actions">
        <div class="job-profile-actions__title">
          <span>Customer</span>
          <strong>{{ detail.companyName || detail.customer || detail.customerEmail || "Customer account" }}</strong>
        </div>

        <div
          class="job-profile-actions__tools"
          @click.stop
          @mousedown.stop
          @mouseup.stop
        >
          <customerChangePopup
            class="job-profile-action-item job-profile-action-item--change"
            title="Change Customer"
            :id="detail._id"
            :inline-action="true"
            @click.native.stop
            @mousedown.native.stop
            @mouseup.native.stop
            v-if="checkCustomerChange(detail.jobStatus)"
          />

          <SendMessage
            class="job-profile-action-item job-profile-action-item--message"
            title="Send Message To Customer"
            :userId="detail.customerId"
            :userName="detail.customer"
            :status="detail.jobStatus"
            :viewOnly="viewOnly"
            :inline-action="true"
            @click.native.stop
            @mousedown.native.stop
            @mouseup.native.stop
            v-permissions="'send-message-jobs'"
          />
          <SendComments
            class="job-profile-action-item job-profile-action-item--comments"
            title="Comments"
            :userId="detail.customerId"
            :userName="detail.customer"
            :status="detail.jobStatus"
            :id="detail.jobId"
            :detail="detail"
            :type="1"
            :viewOnly="viewOnly"
            :inline-action="true"
            :hide-tooltip="true"
            :modern-dialog="true"
            @click.native.stop
            @mousedown.native.stop
            @mouseup.native.stop
          />
        </div>
      </v-card-title>
      <v-card-text class="job-profile-body">
        <v-card class="job-info-panel job-info-panel--identity">
          <v-layout>
            <v-flex xs1><div class="heading pb-3 f-20">Details</div></v-flex>
            <v-flex xs11 pr-3><v-divider class="my-5" /></v-flex>
          </v-layout>

          <v-layout pb-5>
            <v-flex xs3 pr-3>
              <div class="subheading muted">Job ID</div>
              <div class="heading">{{ detail.jobId }}</div>
            </v-flex>
            <v-flex xs3 pr-3>
              <div class="subheading muted">Customer ID</div>
              <div
                class="heading"
                v-if="userDetail && userDetail.customerSerialNumber"
              >
                {{ userDetail.customerSerialNumber }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex xs3 pr-3 v-if="detail.customer">
              <div class="subheading muted">Customer Name</div>
              <div class="heading" v-if="detail.customer">
                {{ detail.customer || "NA" }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex xs3 pr-3 v-else>
              <div class="subheading muted">Customer Email</div>
              <div class="heading">
                {{ detail.customerEmail }}
              </div>
            </v-flex>
            <v-flex xs3 pr-3>
              <div class="subheading muted">Company Name</div>
              <div class="heading" v-if="detail.companyName">
                {{ detail.companyName || "NA" }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
          </v-layout>
          <v-layout pb-5>
            <v-flex xs3 pr-3 class="job-profile-status-cell">
              <div class="subheading muted">Job Status</div>
              <span class="heading job-profile-status-value" style="color: red">{{
                this.jobsStatus(detail.jobStatus)
              }}</span>
            </v-flex>
            <v-flex xs3 pr-3>
              <div class="subheading muted" v-if="detail.natureOfCargo">
                Industry
              </div>
              <div class="heading" v-if="detail.natureOfCargo">
                {{ detail.natureOfCargo.name }}
              </div>

              <v-select
                v-else
                class="dropdown-width"
                :items="natureOfCargos"
                item-text="text"
                v-model="natureOfCargo"
                single-line
                label="Industry"
                @change="updateJob(detail.jobId)"
              />
            </v-flex>
            <v-flex xs3 pr-3>
              <div class="subheading muted">Quote needed by date\time</div>
              <div
                class="heading"
                v-if="detail.quoteNeededBy"
                style="color: blue"
              >
                {{ getTime4(detail.quoteNeededBy) || "NA" }}
              </div>
              <div class="heading" v-else style="color: blue">NA</div>
            </v-flex>
            <v-flex xs3 pr-3>
              <div class="subheading muted" v-if="detail.packingType">
                Packing Type
              </div>
              <div class="heading" v-if="detail.packingType">
                {{ getText(packingTypes, detail.packingType) }}
              </div>
              <v-select
                v-else
                :items="packingTypes"
                class="dropdown-width"
                v-model="packingType"
                single-line
                label="Packing Type"
                @change="updateJob(detail.jobId)"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="detail.proof && detail.proof.length">
            <v-flex xs4 pr-4 pb-5>
              <div class="subheading muted">Proof</div>

              <ProofOfDelivery :deliveryProof="detail.proof" />
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          v-permissions="'billing-status-section'"
          class="job-info-panel job-info-panel--billing"
        >
          <v-layout>
            <v-flex xs2
              ><div class="heading f-20 pb-3">Billing & Status</div></v-flex
            >
            <v-flex xs11 pr-3><v-divider class="my-5" /></v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs4 pr-3>
              <div class="subheading muted">Billing Address</div>
              <div class="heading" v-if="userDetail && userDetail.address">
                {{ userDetail.address }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex xs4 pr-3>
              <div class="subheading muted">Invoicing Country</div>
              <div class="heading" v-if="detail.invoicingCompany">
                {{ getInvoiceBy(detail.invoicingCompany) }}
              </div>
              <div
                class="heading"
                v-else-if="userDetail && userDetail.invoicingCountry"
              >
                {{ getInvoiceBy(userDetail.invoicingCountry) }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex xs4 md4 sm4 pr-4 class="invoicing-branch-field">
              <div class="subheading muted">Invoicing Branch</div>
              <div
                class="heading"
                v-if="detail.invoicingCity == 1 && detail.invoicingCompany == 2"
              >
                FZ
              </div>
              <div
                class="heading"
                v-else-if="
                  detail.invoicingCity == 2 && detail.invoicingCompany == 2
                "
              >
                LLC
              </div>
              <div
                class="heading"
                v-else-if="
                  detail.invoicingCity == 1 && detail.invoicingCompany == 1
                "
              >
                Damman
              </div>
              <div
                class="heading"
                v-else-if="
                  detail.invoicingCity == 2 && detail.invoicingCompany == 1
                "
              >
                Jeddah
              </div>
              <div
                class="heading"
                v-else-if="
                  detail.invoicingCity == 3 && detail.invoicingCompany == 1
                "
              >
                Riyadh
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 1 &&
                  userDetail.invoicingCountry == 2
                "
              >
                FZ
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 2 &&
                  userDetail.invoicingCountry == 2
                "
              >
                LLC
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 1 &&
                  userDetail.invoicingCountry == 1
                "
              >
                Damman
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 2 &&
                  userDetail.invoicingCountry == 1
                "
              >
                Jeddah
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 1 &&
                  userDetail.invoicingCountry == 4
                "
              >
                DXB
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 3 &&
                  userDetail.invoicingCountry == 1
                "
              >
                Riyadh
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 1 &&
                  userDetail.invoicingCountry == 3
                "
              >
                Lahore
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 2 &&
                  userDetail.invoicingCountry == 3
                "
              >
                Karachi
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 3 &&
                  userDetail.invoicingCountry == 3
                "
              >
                Faisalabad
              </div>

              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 3 &&
                  userDetail.invoicingCountry == 5
                "
              >
                Salalah
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 2 &&
                  userDetail.invoicingCountry == 5
                "
              >
                Muscat
              </div>
              <div
                class="heading"
                v-else-if="
                  userDetail &&
                  userDetail.invoicingCity == 1 &&
                  userDetail.invoicingCountry == 5
                "
              >
                Sohar
              </div>
              <div
                class="heading"
                v-else-if="userDetail && userDetail.invoicingCity"
              >
                {{ userDetail.invoicingCompany }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex xs4 md4 sm4 pr-3>
              <div class="payer-strip">
                <div class="payer-strip__item">
                  <span>Payer Category</span>
                  <strong v-if="detail.paymentEntity">
                    {{ detail.paymentEntity }}
                  </strong>
                  <v-radio-group
                    :disabled="detail.jobStatus == 10 || viewOnly == 'view'"
                    class="mt-0 pt-0 payer-strip__radio"
                    v-else
                    v-model="charge"
                    @change="updateJob(detail.jobId)"
                    :mandatory="false"
                  >
                  <v-radio
                    row
                    label="Shipper"
                    value="shipper"
                    color="black"
                  ></v-radio>
                  <v-radio
                    row
                    label="Receiver"
                    value="receiver"
                    color="black"
                  ></v-radio>
                  </v-radio-group>
                </div>
                <div class="payer-strip__item payer-strip__item--entity">
                  <span>
                    <v-icon small>account_balance</v-icon>
                    Billing Entity
                  </span>
                  <strong>
                    {{
                      detail.companyName ||
                        detail.customer ||
                        detail.customerEmail ||
                        "NA"
                    }}
                  </strong>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout pb-5>
            <v-flex xs3 pr-3 v-if="detail.commodity">
              <div class="subheading muted">Commodity</div>
              <span class="heading">{{ detail.commodity }}</span>
            </v-flex>
            <v-flex xs3 pr-3>
              <div class="subheading muted">
                {{
                  detail.workingCountry != "PAK" ? "VAT Number" : "STRN Number"
                }}
              </div>
              <div
                class="heading"
                v-if="userDetail && userDetail.companyVatNumber"
              >
                {{ userDetail.companyVatNumber }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex
              xs3
              pr-3
              v-permissions="'generate-sales-invoice'"
              v-if="
                detail.isReadyToGenerateSalesInvoice &&
                !detail.isSalesInvoiceGenerated &&
                detail.workOrderCompleted &&
                detail.workingCountry != 'PAK' &&
                detail.workingCountry != 'OMAN' &&
                !detail.isSaleOrderInQueue &&
                !detail.isAssignmentCustomerReceiptInitiated &&
                detail.jobStatus != -1
              "
            >
              <div
                class="subheading muted"
                v-permissions="'generate-sales-invoice'"
              >
                Generate Sales Invoice
              </div>

              <div class="heading">
                <button
                  @click="openSiPopup()"
                  type="button"
                  v-permissions="'generate-sales-invoice'"
                  v-if="!detail.isSaleInvoviceBackgroundProcess"
                  :disabled="viewOnly == 'view'"
                  class="track-ass-btn m-t-10 m-l-10 orange-button"
                  title="Generate"
                >
                  Generate
                </button>
                <div
                  v-if="detail.isSaleInvoviceBackgroundProcess"
                  style="word-break: break-word"
                  class="subheading muted"
                >
                  Background process is ongoing.
                </div>
              </div>

              <div v-if="detail.assignementSalesInvoiceGenerated">
                *Assignment level sales invoice has already been generated for
                this.
              </div>
            </v-flex>

            <v-flex
              xs3
              pr-3
              v-if="
                detail.invoiceNumber &&
                detail.isSalesInvoiceGenerated &&
                detail.workOrderCompleted &&
                detail.workingCountry != 'PAK'
              "
            >
              <div class="subheading muted">Sales Invoice Number</div>
              <div class="heading job-field-value--reference">
                {{ detail.invoiceNumber }}
              </div>
            </v-flex>

            <v-flex
              xs3
              pr-3
              v-permissions="'view-sales-invoice'"
              v-if="
                detail &&
                detail.invoicePdfUrl &&
                detail.isSalesInvoiceGenerated &&
                detail.workOrderCompleted &&
                detail.workingCountry != 'PAK'
              "
            >
              <div class="subheading muted">View Sales Invoice</div>
              <div v-if="detail.invoiceNumber == 'NA'">N.A</div>
              <div v-else>
                <div class="heading">
                  <v-btn
                    :disabled="viewOnly == 'view'"
                    outline
                    style="padding: 0 5px"
                    @click="
                      openDownloadAdvance(
                        detail.invoicePdfUrl,
                        detail.isDownloadInvocie,
                        detail.isSaleInvoviceBackgroundProcess,
                        detail.invoiceNumber
                      )
                    "
                    color="orange"
                    ><v-icon style="margin: 0px !important" right dark
                      >download</v-icon
                    >
                    Download
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          v-permissions="'price-section'"
          class="job-info-panel job-info-panel--commercial"
        >
          <v-layout>
            <v-flex xs1> <div class="heading pb-3 f-20">Price</div></v-flex>
            <v-flex xs11 pr-3><v-divider class="my-5" /></v-flex>
          </v-layout>

          <v-layout pb-5>
            <v-flex xs3 pr-3>
              <div class="subheading muted">Total Price</div>
              <span class="heading" v-if="detail.jobPrice"
                >{{ $formatPrice(detail.jobPrice) }}
                {{ detail.customerCurrency }}</span
              >
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex xs3>
              <div class="subheading muted" v-if="detail.customerCurrency">
                Currency
              </div>
              <div class="heading" v-if="detail.customerCurrency">
                {{ detail.customerCurrency }}
              </div>
              <v-select
                v-else
                v-model="currency"
                :items="currency"
                item-text="currency"
                item-value="abbr"
                label="Currency"
                persistent-hint
                return-object
                single-line
                :disabled="viewOnly == 'view'"
                @change="updateJob(detail.jobId)"
              ></v-select>
            </v-flex>
            <v-flex xs3 pr-3>
              <div class="subheading muted">Price Type</div>
              <span class="heading" v-if="detail.chargesType">{{
                detail.chargesType
              }}</span>
              <div class="heading" v-else>Exclusive</div>
            </v-flex>
          </v-layout>
          <v-layout v-if="detail.workingCountry == 'PAK'">
            <v-flex xs1> <div class="heading pb-3 f-20">Contact</div></v-flex>
            <v-flex xs11 pr-3><v-divider class="my-5" /></v-flex>
          </v-layout>

          <v-layout pb-5 v-if="detail.workingCountry == 'PAK'">
            <v-flex xs3 pr-3>
              <div class="subheading muted">Name</div>
              <span class="heading" v-if="detail.contactPersonName">{{
                detail.contactPersonName
              }}</span>
              <div class="heading" v-else>NA</div>
            </v-flex>
            <v-flex xs3>
              <div class="subheading muted" v-if="detail.customerCurrency">
                Address
              </div>
              <div class="heading" v-if="detail.contactAddress">
                {{ detail.contactAddress || N.A }}
              </div>
              <div class="heading" v-else>NA</div>
            </v-flex>
          </v-layout>

          <v-layout row class="py-2"> </v-layout>
          <v-form
            ref="customerForm"
            v-model="valid"
            lazy-validation
            onSubmit="return false;"
          >
            <v-layout
              v-if="!userDetail.address || !userDetail.companyVatNumber"
            >
              <v-flex xs5 class="px-2">
                <span class="muted caption">Billing Address*</span>
                <v-text-field
                  placeholder="Provide Customer Billing Address"
                  v-model="customer.customerAddress"
                  :value="customer.customerAddress"
                  single-line
                  :rules="[rules.noWhiteSpace, rules.required]"
                  maxlength="100"
                  class="pt-0 currencyTitle"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 class="px-2">
                <span class="muted caption">{{
                  detail.workingCountry != "PAK" ? "VAT Number*" : "STRN Number"
                }}</span>
                <v-text-field
                  :placeholder="
                    detail.workingCountry != 'PAK'
                      ? 'VAT Number*'
                      : 'STRN Number*'
                  "
                  v-model="customer.companyVatNumber"
                  :value="customer.companyVatNumber"
                  single-line
                  :rules="[rules.vatNumber, rules.required]"
                  counter
                  maxlength="20"
                  readonly="true"
                  class="pt-0 currencyTitle"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <button
                  class="track-ass-btn"
                  flat
                  prepend-icon
                  color="white darken-1"
                  :disabled="detail.jobStatus == 10 || viewOnly == 'view'"
                  @click="updateCustomerInfo(detail.jobId)"
                  :_id="detail._id"
                  :loading="loading"
                >
                  Update Info
                </button>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout>
            <v-flex xs3 pr-4>
              <div class="subheading muted">Additional Details</div>
              <div class="heading">{{ detail.otherDetails || "N.A. " }}</div>
            </v-flex>

            <v-flex
              xs3
              pr-4
              class="job-work-order-cell"
              @click.stop
              @mousedown.stop
              @mouseup.stop
              v-if="
                detail.workingCountry != 'PAK' &&
                detail.workingCountry != 'OMAN'
              "
            >
              <div class="subheading muted">Work Order</div>

              <div
                v-if="
                  userDetail &&
                  userDetail.address &&
                  userDetail.companyVatNumber &&
                  detail.workOrderCompleted == true
                "
              >
                Ref Id: {{ detail.workOrderRefId }}
              </div>
              <div
                v-else-if="
                  !userDetail.invoicingCity && userDetail.invoicingCountry
                "
              >
                Please update customer invoicing details.
              </div>
              <div
                v-else-if="
                  !userDetail.invoicingCity &&
                  !userDetail.invoicingCountry &&
                  !detail.invoicingCompany &&
                  !detail.invoicingCity
                "
              >
                Please update customer invoicing details.
              </div>
              <div
                v-else-if="
                  userDetail &&
                  userDetail.address &&
                  userDetail.companyVatNumber &&
                  detail.workOrderCompleted == false
                "
              >
                <button
                  v-if="
                    (userDetail &&
                      userDetail.invoicingCity &&
                      userDetail.invoicingCountry) ||
                    (detail.invoicingCompany &&
                      detail.invoicingCity &&
                      !detail.isWorkOrderInQueue)
                  "
                  class="track-ass-btn"
                  flat
                  prepend-icon
                  color="white darken-1"
                  @click="retry(detail.jobId)"
                  :_id="detail._id"
                  :loading="loading"
                  :disabled="viewOnly == 'view' || detail.jobStatus == 10"
                >
                  Retry
                </button>
                <div v-if="isWorkOrderInQueue">
                  Background process is ongoing
                </div>
              </div>
              <div
                v-else-if="
                  userDetail &&
                  userDetail.companyVatNumber &&
                  userDetail.address
                "
              >
                <button
                  class="track-ass-btn"
                  v-if="!detail.isWorkOrderInQueue"
                  flat
                  prepend-icon
                  color="white darken-1"
                  @click="retry(detail.jobId)"
                  :_id="detail._id"
                  :loading="loading"
                  :disabled="viewOnly == 'view'"
                >
                  Create
                </button>
                <div v-if="detail.isWorkOrderInQueue">
                  Background process is ongoing
                </div>
              </div>
              <div v-else>
                Please Update Customer Billing address and Vat number*
              </div>
            </v-flex>
            <v-flex
              xs3
              pr-4
              v-if="
                detail.workingCountry != 'PAK' &&
                detail.workingCountry != 'OMAN'
              "
            >
              <div
                class="subheading muted"
                v-if="detail.voucherIdRealBooks || detail.errorWhileRealbooks"
              >
                Sales Voucher No
              </div>
              <div v-if="detail.isSaleOrderInQueue">
                Background process is ongoing
              </div>
              <div v-else-if="!detail.workOrderCompleted">
                Work order is not generated
              </div>
              <div v-else-if="detail.jobStatus == -1">Job is cancelled</div>
              <div
                v-else-if="
                  detail.isSalesOrderIntiated && detail.voucherIdRealBooks
                "
              >
                {{ detail.voucherIdRealBooks }}
              </div>
              <div
                v-else-if="
                  detail.isSalesOrderIntiated == false &&
                  detail.workOrderCompleted == true &&
                  detail.errorWhileRealbooks == true
                "
              >
                <span v-if="detail.isSaleOrderInQueue">
                  Background process are ongoing
                </span>
                <span
                  v-if="
                    !detail.isSaleOrderInQueue &&
                    detail.isSaleOrderBackgroundProcess &&
                    detail.errorWhileRealbooks
                  "
                  >Data inappropriate, kindly update data</span
                >
                <button
                  class="track-ass-btn"
                  flat
                  v-if="
                    !detail.isSaleOrderInQueue &&
                    !detail.isSaleOrderBackgroundProcess &&
                    detail.errorWhileRealbooks
                  "
                  prepend-icon
                  color="white darken-1"
                  @click="retrySO(detail.jobId)"
                  :_id="detail._id"
                  :loading="loading"
                  :disabled="viewOnly == 'view'"
                >
                  Retry
                </button>
              </div>
              <div
                v-else-if="
                  detail.isReadyToGenerateSalesInvoice &&
                  detail.isSalesOrderIntiated == false &&
                  !detail.voucherIdRealBooks &&
                  detail.workOrderCompleted == true
                "
              >
                <span v-if="detail.isSaleOrderInQueue">
                  Background process is ongoing
                </span>
                <button
                  v-if="!detail.isSaleOrderInQueue"
                  class="track-ass-btn"
                  flat
                  prepend-icon
                  color="white darken-1"
                  @click="retrySO(detail.jobId)"
                  :_id="detail._id"
                  :loading="loading"
                  :disabled="viewOnly == 'view'"
                >
                  Create
                </button>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-card-text>
    </v-card>
    <CustomerAdvancePopup
      v-model="customerAdvanceDialog"
      :currency="customerAdvanceCurrency"
      :max-amount="customerAdvanceMax"
      advance-type="job"
      :advance-id="customerAdvanceId"
      :title="customerAdvanceCopy.title"
      :message="customerAdvanceCopy.message"
      :hint="customerAdvanceCopy.hint"
      :yes-text="customerAdvanceCopy.yesText"
      @confirm="onCustomerAdvanceConfirm"
      @cancel="onCustomerAdvanceCancel"
    />

    <GenerateInvoiceDialog
      :open="dialog1"
      v-model="bank"
      :banks="bankInfo"
      :loading="loading"
      @change="setCustomerValues"
      @cancel="closeBankInfo()"
      @confirm="generateInvoiceNumber()"
    >
      <div v-if="!userDetail.invoiceDay" slot="prompt">
        <p class="generate-invoice-lead">Set the credit duration first</p>
        <p class="generate-invoice-hint">
          This customer has no credit duration yet. Save one to continue to the
          invoice.
        </p>
        <label class="generate-invoice-label" for="generate-invoice-credit">
          Credit duration
        </label>
        <div class="generate-invoice-credit-row">
          <v-text-field
            id="generate-invoice-credit"
            v-model="invoiceDay"
            placeholder="e.g. 30"
            suffix="days"
            type="number"
            single-line
            hide-details
            class="generate-invoice-field"
          />
          <v-btn
            class="oms-btn oms-btn--primary"
            @click="addCreditDuration()"
            >Save</v-btn
          >
        </div>
      </div>
    </GenerateInvoiceDialog>
    <v-snackbar
      :timeout="3000"
      bottom
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
    <success-dialog
      :content="x.message"
      :show="x.success"
      :onclose="closeMessage"
    />
  </div>
</template>

<script>
import { StorageKeys } from "../../../constants/constants";
import { EventBus } from "../../../event-bus.js";
import {
  TruckTypes,
  PackingTypes,
  NatureOfCargos,
  JobTypes,
} from "../../../constants/constants";
import SendMessage from "@/components/Pop-ups/SendMessage";
import SendComments from "@/components/Pop-ups/SendComments";
import SuccessDialog from "@/components/Common/SuccessDialog";
import moment from "moment";
import ErrorBox from "@/components/Common/ErrorBox";
import ProofOfDelivery from "@/components/Pop-ups/ProofOfDelivery";
import customerChangePopup from "@/components/Pop-ups/customerChangePopup";
import CustomerAdvancePopup from "@/components/Common/CustomerAdvancePopup.vue";
import GenerateInvoiceDialog from "@/components/Common/GenerateInvoiceDialog";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
import {
  editInvoiceDay,
  generateSalesInvoice,
  sendSMStoDriver,
  generateWorkOrder,
  generateSaleOrder,
  updateJob,
  updateJobCustomerAdvance,
} from "../../../constants/api-urls";
import { apiErrorMessage } from "@/utils/customerAdvance";
import Loading from "vue-loading-overlay";
import downloadMixin from "@/mixins/downloadMixin";
import "vue-loading-overlay/dist/vue-loading.min.css";
export default {
  mixins: [downloadMixin],

  created() {
    if (localStorage.getItem("workingCountries")) {
      let workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          this.workingCountry = key.value;
        }
      });
    }
    this.jobTypes = JobTypes;
    setTimeout(() => {
      return new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.onload = () => {
          this.initLoadingAutocomplete();
          this.initUnloadingAutocomplete();
        };
        script.src =
          "https://maps.google.com/maps/api/js?libraries=places&key=AIzaSyAbH5dlLsPapMreDphjjYtTbdj0_xHdLt8";
        document.head.appendChild(script);
      });
    }, 2500);

    delete this.axios.defaults.headers.common["token"];
    let token = localStorage.getItem(StorageKeys.SessionKey);
    let config = {
      headers: {
        authorization: `bearer ${token}`,
      },
    };
    this.t = config.headers.authorization;
  },
  components: {
    Loading,
    GenerateInvoiceDialog,
    ErrorBox,
    ProofOfDelivery,
    SendMessage,
    SuccessDialog,
    SendComments,
    customerChangePopup,
    CustomerAdvancePopup,
  },
  props: {
    workingcountry: String,
    viewOnly: String,
    userDetail: Object,
    detail: {
      sourceCountry: String,
      sourceCountryArabic: String,
      destinationLocation: String,
      customer: String,
      packingType: Number,
      otherDetails: String,
      sourceCity: String,
      sourceCityArabic: String,
      destinationCity: String,
      destinationCityArabic: String,
      customerCurrency: String,
      invoiceCountry: String,
      invoiceCity: String,
      truckType: Number,
      numberOfAssignmentsRequired: Number,
      jobId: Number,
      _id: String,
      sourceLocation: String,
      natureOfCargo: Number,
      createdAt: Number,
      startDate: Number,
      jobStatus: Number,
      destinationCountry: String,
      destinationCountryArabic: String,
      destinationLatLong: Array,
      sourceLatLong: Array,
      deliveryProof: Array,
      jobType: String,
      jobGeoType: String,
      jobMode: String,
      invoicingCompany: String,
      invoicingCity: String,
      workingCountry: String,
    },
  },
  computed: {
    /* Generating asks whether there is an advance at all. Downloading an
       invoice that already has one is an edit, so it is worded as one. */
    customerAdvanceCopy() {
      if (this.customerAdvanceMode == "download") {
        return {
          title: "Edit Customer Advance",
          message:
            "Do you want to update the customer advance for this shipment?",
          hint: "Change the amount, or choose No to keep it as it is.",
          yesText: "Update",
        };
      }
      return {
        title: "Customer Advance",
        message: "Is there any customer advance for this shipment?",
        hint: "Enter the amount, or choose No if there is no advance.",
        yesText: "Yes",
      };
    },
  },
  watch: {
    detail(val) {},
  },
  data() {
    return {
      workingCountry: "",
      invoiceDay: null,
      confirmation: "",
      bankInfo: [],
      bankName: [],
      bank: "",
      beneficiaryName: "",
      branchCode: "",
      ibanNo: "",
      swiftCode: "",
      accountNo: "",
      bankId: "",
      valid: true,
      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },
      dialog1: false,
      customerAdvanceDialog: false,
      customerAdvanceCurrency: "",
      customerAdvanceMax: null,
      customerAdvanceAmount: null,
      customerAdvanceId: null,
      customerAdvanceMode: "generate",
      pendingDownload: null,
      invoiceCountry: "",
      charge: "",
      natureOfCargo: "",
      packingType: "",
      currency: [
        { currency: "AED", abbr: "aed" },
        { currency: "SAR", abbr: "sar" },
      ],
      x: {
        message: "",
        loading: false,
        success: false,
        error: null,
      },
      dialog: false,
      loading: false,
      error: null,
      readOnly: true,
      profileUpdateLoading: false,
      natureOfCargos: NatureOfCargos,
      truckTypes: TruckTypes,
      packingTypes: PackingTypes,
      updateInfo: {
        sourceLocation: this.detail.sourceLocation,
        sourceCity: this.detail.sourceCity,
        sourceCityArabic: this.detail.sourceCityArabic,
        sourceCountry: this.detail.sourceCountry,
        sourceCountryArabic: this.detail.sourceCountryArabic,

        destinationLocation: this.detail.destinationLocation,
        destinationCity: this.detail.destinationCity,
        destinationCityArabic: this.detail.destinationCityArabic,

        destinationCountry: this.detail.destinationCountry,
        destinationCountryArabic: this.detail.destinationCountryArabic,

        destinationlong: this.detail.destinationLatLong,
        destinationlat: this.detail.destinationLatLong[1],
        sourcelong: this.detail.sourceLatLong[0],
        sourcelat: this.detail.sourceLatLong[1],
      },
      customer: {
        customerAddress: null,
        companyVatNumber: null,
      },
      rules: {
        number: (v) => /^[1-9]*$/.test(v) || "Please enter valid amount",
        required: (value) => !!value || "This field is required.",
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "Enter valid value.",
        vatNumber: (v) =>
          /^([a-zA-Z0-9_-]){1,20}$/.test(v) || "Please Enter Valid Vat Number",
      },
    };
  },
  updated: function () {},
  methods: {
    addCreditDuration() {
      if (!this.invoiceDay) {
        this.loading = false;
        this.error = "Please enter the credit duration";
        return;
      }

      if (!this.invoiceDay.match(/^([1-9][0-9]{0,3}|10000)$/)) {
        this.loading = false;
        this.error =
          "Please enter valid duration greater than 0 less than 10000";
        return;
      }
      this.loading = true;
      let url = editInvoiceDay;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        userId: this.userDetail._id,
        invoiceDay: parseInt(this.invoiceDay),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.items = response.data.data;
          this.loading = false;
          this.x.success = true;
          this.$eventBus.$emit("refresh-job");
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    async checkViewInvoice(
      url,
      isDownloadInvocie,
      isSaleInvoviceBackgroundProcess,
      invoiceNumber
    ) {
      this.loading = true;
      this.operationName = "view-sales-invoice";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        if (!isDownloadInvocie || isSaleInvoviceBackgroundProcess) {
          this.loading = false;
          this.error = "Background process is ongoing ";
          return;
        }
        /* Mixin function*/
        this.forceDownload(url, "Sales Invoice" + " " + invoiceNumber);
      } else {
        this.loading = false;
        return;
      }
      this.loading = false;
    },
    checkCustomerChange(e) {
      if (e == 4 || e == 5 || e == 6 || e == 7 || e == 11) {
        return true;
      } else {
        return false;
      }
    },
    closeBankInfo() {
      this.dialog1 = false;
      this.customerAdvanceAmount = null;
      this.invoiceDay = null;
      this.bankInfo = [];
      this.bank = "";

      (this.beneficiaryName = ""),
        (this.branchCode = ""),
        (this.accountNo = ""),
        (this.ibanNo = ""),
        (this.bankId = ""),
        (this.swiftCode = "");
    },
    async generateInvoiceNumber() {
      this.loading = true;
      this.operationName = "generate-sales-invoice";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (!this.bank) {
        this.loading = false;
        this.error = "Please choose bank before generating the invoice";
        return;
      }
      if (y) {
        this.loading = true;
        if (!this.userDetail.invoiceDay) {
          this.loading = false;
          this.error = "Please enter the credit limit duration";
          return;
        }
        let url = generateSalesInvoice;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = { jobId: this.$route.params.id, bankId: this.bankId };
        /* Customer advance is UAE only. KSA and every other working country
           keep the payload they had before. */
        if (
          this.detail &&
          this.detail.workingCountry == "UAE" &&
          this.customerAdvanceAmount !== null
        ) {
          body.customerAdvance = this.customerAdvanceAmount;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.items = response.data.data;
            this.loading = false;
            this.x.success = true;
            this.closeBankInfo();
            this.customerAdvanceAmount = null;
            this.$eventBus.$emit("refresh-job");
            // this.x.message = "Drivers notified";
          },
          (error) => {
            this.loading = false;
            this.error = error.response.data.message;
          }
        );
      } else {
        this.loading = false;
        return;
      }
    },
    getTime(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    getTime4(date) {
      return moment(date).format("ll LT");
    },

    setShipmentValues() {
      this.detail.jobGeoType = 1;
      this.detail.jobMode = 1;
      this.detail.JobType = 1;
    },

    notifyDrivers() {
      let url = sendSMStoDriver;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { jobId: this.$route.params.id };

      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.items = response.data.data;

          this.x.loading = false;
          this.x.success = true;
          this.x.message = "Drivers notified";
        },
        (error) => {
          this.loading = false;
          this.error = "Failed to update inquiry status";
        }
      );
    },
    driverJob(id) {
      this.$router.push(`/driverfilters/${id}`);
    },
    retry(jobId) {
      this.loading = true;
      let url = generateWorkOrder;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { jobId: jobId.toString() };

      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.x.success = true;
          this.x.message = response.data.data.message;
          this.loading = false;
          setTimeout(() => (this.dialog = false), 100);
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    retrySO(jobId) {
      let url = generateSaleOrder;
      this.loading = true;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { jobId: jobId.toString() };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          //this.x.success = true;
          this.$emit("updateJobs");
          this.loading = false;
          setTimeout(() => (this.dialog = false), 100);
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    removeEmptyOrNull(myObj) {
      Object.keys(myObj).forEach(
        (key) =>
          (myObj[key] == null ||
            myObj[key] == "" ||
            myObj[key] === undefined) &&
          delete myObj[key]
      );

      return myObj;
    },
    closeMessage() {
      this.x.success = false;
      this.$emit("updateJobs");
      this.reset();
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Active";
        case 2:
          return "Complete";
        case 3:
          return "Customer Rate Accepted";
        case 4:
          return "Finding Drivers";
        case 5:
          return "Driver Assigned";
        case 6:
          return "In-Transit";
        case 7:
          return "Shipment Offloaded";
        case 8:
          return "Payment Pending";
        case 9:
          return "Payment Done";
        case 10:
          return "Low Credit Limit";

        case -1:
          return "Job Cancelled";
        default:
          return "Unknown";
      }
    },
    getText(arr = [], val) {
      let finalEl = arr
        .filter((val) => val !== undefined)
        .find((el) => el.value === val);
      return finalEl ? finalEl.text : "NA";
    },
    getInvoiceBy(type) {
      switch (type) {
        case "1":
          return "KSA";
        case "2":
          return "UAE";
        case "3":
          return "PAK";
        case "4":
          return "UAE LA";
        case "5":
          return "OMAN";
        default:
          return "NA";
      }
    },
    getLocation(...arr) {
      return arr ? arr.reduce((prev, curr) => prev + ", " + curr) : "NA";
    },
    reset() {
      this.readOnly = true;
      this.updateInfo = Object.assign(
        {},
        {
          sourceLocation: this.updateInfo.sourceLocation,
          sourceCity: this.updateInfo.sourceCity,
          sourceCityArabic: this.updateInfo.sourceCityArabic,
          sourceCountry: this.updateInfo.sourceCountry,
          sourceCountryArabic: this.updateInfo.sourceCountryArabic,
          destinationLocation: this.updateInfo.destinationLocation,
          destinationCity: this.updateInfo.destinationCity,
          destinationCityArabic: this.updateInfo.destinationCityArabic,

          destinationCountry: this.updateInfo.destinationCountry,
          destinationCountryArabic: this.updateInfo.destinationCountryArabic,

          destinationlong: this.updateInfo.destinationLatLong[0],
          destinationlat: this.updateInfo.destinationLatLong[1],
          sourcelong: this.updateInfo.sourceLatLong[0],
          sourcelat: this.updateInfo.sourceLatLong[1],
        }
      );
    },

    setCustomerValues(val) {
      var data = this.bankInfo.filter((v) => {
        if (v.value === val) return v;
      });

      (this.beneficiaryName = data[0].beneficiaryName),
        (this.branchCode = data[0].branchCode),
        (this.accountNo = data[0].accountNo),
        (this.ibanNo = data[0].ibanNo),
        (this.bankId = data[0].bankId),
        (this.swiftCode = data[0].swiftCode);
      // this.beneficiaryName = data[0].beneficiaryName;
    },
    /* Shared setup for both places that ask for the advance. The popup
       prefills itself from this job's saved advance. */
    openCustomerAdvance(mode) {
      this.customerAdvanceAmount = null;
      this.customerAdvanceCurrency = this.detail.customerCurrency || "";
      /* The cap is the invoice amount that comes back with the saved
         advance, so nothing is set here. */
      this.customerAdvanceId = this.detail.jobId || this.$route.params.id;
      this.customerAdvanceMode = mode;
      this.customerAdvanceDialog = true;
    },

    async openSiPopup() {
      /* For UAE, ask for the customer advance first. Every other working
         country, and anyone who cannot generate the sales invoice, keeps
         going straight into the existing sales invoice flow. */
      this.operationName = "generate-sales-invoice";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (this.detail && this.detail.workingCountry == "UAE" && y) {
        this.openCustomerAdvance("generate");
        return;
      }
      this.fetchBank();
    },

    /* Downloading an already generated invoice asks for the advance too,
       so it can be revised before the invoice is opened. */
    async openDownloadAdvance(
      url,
      isDownloadInvocie,
      isSaleInvoviceBackgroundProcess,
      invoiceNumber
    ) {
      this.pendingDownload = {
        url,
        isDownloadInvocie,
        isSaleInvoviceBackgroundProcess,
        invoiceNumber,
      };
      if (this.detail && this.detail.workingCountry == "UAE") {
        /* Only whoever can generate the sales invoice may edit the advance,
           everyone else just downloads it. */
        this.operationName = "generate-sales-invoice";
        let y = await this.checkOpertaionPermission(this.operationName);
        if (y) {
          this.openCustomerAdvance("download");
          return;
        }
      }
      this.runPendingDownload();
    },

    runPendingDownload() {
      const pending = this.pendingDownload;
      this.pendingDownload = null;
      if (!pending) return;
      this.checkViewInvoice(
        pending.url,
        pending.isDownloadInvocie,
        pending.isSaleInvoviceBackgroundProcess,
        pending.invoiceNumber
      );
    },

    /* Both No and Yes resume whichever flow opened the popup, Yes also
       keeps whatever amount was entered. */
    onCustomerAdvanceConfirm({ confirmed, amount }) {
      this.customerAdvanceAmount = amount;
      const shouldSave = confirmed && amount !== null;

      if (this.customerAdvanceMode == "download") {
        if (shouldSave) this.saveAdvanceThenDownload(amount);
        else this.runPendingDownload();
        return;
      }

      if (shouldSave) {
        this.saveJobCustomerAdvance(this.customerAdvanceId, amount);
      }
      this.fetchBank();
    },

    /* Editing the advance regenerates the invoice, so the download holds
       until the new PDF arrives rather than handing back the stale one. */
    saveAdvanceThenDownload(amount) {
      this.loading = true;
      this.saveJobCustomerAdvance(this.customerAdvanceId, amount).then(
        (invoice) => {
          this.loading = false;
          this.pendingDownload = null;
          if (!invoice) return;
          /* The rebuilt PDF is uploaded under a fresh name, so its URL comes
             back on this response. The list and detail endpoints are cached
             and would still hand back the previous one. */
          const url = invoice.invoicePdfUrl;
          if (!url) {
            this.error =
              "The invoice was updated but its PDF link was not returned. Please try the download again.";
            return;
          }
          this.checkViewInvoice(
            url,
            true,
            false,
            invoice.invoiceNumber || this.detail.invoiceNumber
          );
          /* Refresh so the screen reflects the new advance and PDF link. */
          this.$eventBus.$emit("refresh-job");
        }
      );
    },

    /* Saves the advance against the job. The flow that opened the popup
       carries on either way, a failure is surfaced but does not block it. */
    saveJobCustomerAdvance(jobId, amount) {
      if (!jobId) return Promise.resolve(false);
      if (!this.detail || this.detail.workingCountry != "UAE") {
        return Promise.resolve(false);
      }
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { jobId: jobId.toString(), customerAdvance: amount };
      return this.axios
        .post(this.constants.apiUrl + updateJobCustomerAdvance, body, config)
        .then(
          (response) => {
            /* The response carries the rebuilt invoice, including its new
               PDF URL. */
            const payload = response.data || {};
            return payload.data || payload;
          },
          (error) => {
            this.error = apiErrorMessage(
              error,
              "Could not save the customer advance."
            );
            return null;
          }
        );
    },

    onCustomerAdvanceCancel() {
      this.customerAdvanceAmount = null;
      this.pendingDownload = null;
    },

    fetchBank() {
      this.dialog1 = true;

      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        invoicingCity: {
          code: this.detail.invoicingCity,
        },
        invoicingCountry: {
          code: this.detail.invoicingCompany,
        },
      };
      let { apiUrl } = this.constants;
      this.axios.post(`${apiUrl}/accounts/getBankDetails`, body, config).then(
        (response) => {
          const { data = null } = response.data;
          /* Replace, never append, so reopening the bank step does not list
             every bank again. */
          this.bankInfo = data.map((element) => ({
            text: element.bankName,
            value: element._id,
            beneficiaryName: element.beneficiaryName,
            branchCode: element.branchCode,
            accountNo: element.accountNo,
            ibanNo: element.ibanNo,
            bankId: element._id,
            swiftCode: element.swiftCode,
            
            // companyName: element.companyName,
            // companyVatNumber: element.companyVatNumber,
            // address: element.address
            //   ? element.address.replaceAll("\n", ", ")
            //   : "",
            // invoicingCity: element.invoicingCity,
            // invoicingCountry: element.invoicingCountry,
            // selectedIndustry: element.selectedIndustry,
          }));

          // this.bankName = response.data.data[2].bankName;
        },
        (error) => {
          this.error = "Something went wrong. Please try again later!";
          this.loading = false;
        }
      );
    },

    initLoadingAutocomplete() {
      // Create the autocomplete object, restricting the search predictions to
      // geographical location types.
      var autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete")
      );

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      // autocomplete.setFields(['address_component', 'geometry']);

      // When the user selects an address from the drop-down, populate the
      // address fields in the form.

      autocomplete.addListener("place_changed", () => {
        // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace();

        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.

        this.updateInfo.sourceLocation = place.formatted_address;
        this.updateInfo.sourcelat = place.geometry.location.lat();
        this.updateInfo.sourcelong = place.geometry.location.lng();

        var componentMap = {
          country: "country",
          locality: "locality",
        };
        var componentMap2 = {
          country: "country",
          administrative_area_level_1: "administrative_area_level_1",
        };
        var x = [];
        var y = [];
        for (var i = 0; i < place.address_components.length; i++) {
          var types = place.address_components[i].types; // get types array of each component
          for (var j = 0; j < types.length; j++) {
            // loop through the types array of each component as types is an array and same thing can be indicated by different name.As you can see in the json object above
            var component_type = types[j];
            // check if this type is in your component map.If so that means you want this component
            if (componentMap.hasOwnProperty(component_type)) {
              x.push(place.address_components[i]["long_name"]);
            }
            if (componentMap2.hasOwnProperty(component_type)) {
              y.push(place.address_components[i]["long_name"]);
            }
          }
        }
        if (x.length === 2) {
          this.updateInfo.sourceCountry = x[1];
          this.updateInfo.sourceCity = x[0];
        } else {
          this.updateInfo.sourceCountry = y[1];
          this.updateInfo.sourceCity = y[0];
        }
        if (!this.updateInfo.sourceCity.match(/^[ A-Za-z0-9_@.,\/#&+\-éÉ]*$/)) {
          this.updateInfo.sourceCity = "";
        }
      });
    },
    initUnloadingAutocomplete() {
      // Create the autocomplete object, restricting the search predictions to
      // geographical location types.
      var autocomplete2 = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete2")
      );

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      // autocomplete2.setFields(['address_component', 'geometry']);

      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      autocomplete2.addListener("place_changed", () => {
        // Get the place details from the autocomplete object.
        var place = autocomplete2.getPlace();

        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.

        this.updateInfo.destinationLocation = place.formatted_address;
        this.updateInfo.destinationlong = place.geometry.location.lng();
        this.updateInfo.destinationlat = place.geometry.location.lat();

        var componentMap = {
          country: "country",
          locality: "locality",
        };
        var componentMap2 = {
          country: "country",
          administrative_area_level_1: "administrative_area_level_1",
        };
        var x = [];
        var y = [];
        for (var i = 0; i < place.address_components.length; i++) {
          var types = place.address_components[i].types; // get types array of each component
          for (var j = 0; j < types.length; j++) {
            // loop through the types array of each component as types is an array and same thing can be indicated by different name.As you can see in the json object above
            var component_type = types[j];
            // check if this type is in your component map.If so that means you want this component
            if (componentMap.hasOwnProperty(component_type)) {
              x.push(place.address_components[i]["long_name"]);
            }
            if (componentMap2.hasOwnProperty(component_type)) {
              y.push(place.address_components[i]["long_name"]);
            }
          }
        }
        if (x.length === 2) {
          this.updateInfo.destinationCountry = x[1];
          this.updateInfo.destinationCity = x[0];
        } else {
          this.updateInfo.destinationCountry = y[1];
          this.updateInfo.destinationCity = y[0];
        }
        if (
          !this.updateInfo.destinationCity.match(/^[ A-Za-z0-9_@.,\/#&+\-éÉ]*$/)
        ) {
          this.updateInfo.destinationCity = "";
        }
      });
    },
    updateLocation() {
      this.profileUpdateLoading = true;
      if (!this.updateInfo.sourcelong && !this.updateInfo.sourcelat) {
        this.error =
          "Please select source address from the suggestions dropdown!";
        this.profileUpdateLoading = false;
        return;
      }

      if (!this.updateInfo.destinationlong && !this.updateInfo.destinationlat) {
        this.error =
          "Please select destination address from the suggestions dropdown!";
        this.profileUpdateLoading = false;
        return;
      }

      if (!this.updateInfo.sourceCity) {
        this.error = "Please select source city before moving ahead!";
        this.profileUpdateLoading = false;
        return;
      }

      if (!this.updateInfo.sourceCountry) {
        this.error = "Please select source country before moving ahead!";
        this.profileUpdateLoading = false;
        return;
      }

      if (!this.updateInfo.destinationCity) {
        this.error = "Please select destination city before moving ahead!";
        this.profileUpdateLoading = false;
        return;
      }

      if (!this.updateInfo.destinationCountry) {
        this.error = "Please select destination country before moving ahead!";
        this.profileUpdateLoading = false;
        return;
      }
      let { jobId } = this.detail;
      jobId = jobId.toString();

      let {
        sourceLocation,
        sourceCity,
        sourceCityArabic,
        sourceCountry,
        sourceCountryArabic,
        destinationLocation,
        destinationCity,
        destinationCityArabic,
        destinationCountry,
        destinationCountryArabic,
        destinationlong,
        destinationlat,
        sourcelong,
        sourcelat,
      } = this.updateInfo;

      destinationlong = destinationlong.toString();
      destinationlat = destinationlat.toString();
      sourcelong = sourcelong.toString();
      sourcelat = sourcelat.toString();

      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios
        .post(
          `${this.constants.apiUrl}/dmsAdmin/assignmentLocation`,
          {
            jobId,
            sourceLocation,
            sourceCity,
            sourceCityArabic,
            sourceCountry,
            sourceCountryArabic,
            destinationLocation,
            destinationCity,
            destinationCityArabic,
            destinationCountry,
            destinationCountryArabic,
            destinationlong,
            destinationlat,
            sourcelong,
            sourcelat,
          },
          config
        )
        .then(
          (response) => {
            const { status, data } = response.data;
            if (status === 200) {
              this.x.success = true;
              this.x.message = "Location updated successfully";
              this.updateInfo = Object.assign(
                {},
                {
                  sourceLocation,
                  sourceCity,
                  sourceCityArabic,
                  sourceCountry,
                  sourceCountryArabic,
                  destinationLocation,
                  destinationCity,
                  destinationCityArabic,
                  destinationCountry,
                  destinationCountryArabic,
                  sourcelat,
                  sourcelong,
                  destinationlong,
                  destinationlat,
                }
              );
            }
            this.profileUpdateLoading = false;
            this.readOnly = true;
          },
          (error) => {
            this.error = error.response.data.message;
            this.profileUpdateLoading = false;
          }
        );
    },
    updateCustomerInfo(jobId) {
      if (this.$refs.customerForm.validate()) {
        this.loading = true;
        let url = updateJob;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          jobId: jobId.toString(),
          customerVatNo: this.customer.companyVatNumber.trim(),
          customerAddress: this.customer.customerAddress.trim(),
        };
        body = this.removeEmptyOrNull(body);
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.x.success = true;
            this.x.message = response.data.message;
            this.loading = false;
            setTimeout(() => (this.dialog = false), 100);
          },
          (error) => {
            this.loading = false;
            this.error = error.response.data.message;
          }
        );
      }
    },
    updateJob(jobId) {
      this.loading = true;
      let url = updateJob;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        jobId: jobId.toString(),
        customerCurrency: this.currency.currency,
        invoicingCompany: this.invoicingCompany,
        paymentEntity: this.charge,
        packingType: this.packingType.toString(),
        natureOfCargo: this.natureOfCargo.toString(),
      };
      body = this.removeEmptyOrNull(body);
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.x.success = true;
          this.x.message = response.data.message;
          this.loading = false;
          setTimeout(() => (this.dialog = false), 100);
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    updateInvoice(jobId) {
      this.loading = true;
      let url = updateJob;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        jobId: jobId.toString(),
        invoicingCompany: this.detail.invoicingCompany,
      };
      body = this.removeEmptyOrNull(body);
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.x.success = true;
          this.x.message = response.data.message;
          this.loading = false;
          setTimeout(() => (this.dialog = false), 100);
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    goback() {
      if (localStorage.getItem("activeMenu") == 2) this.$router.push(`/jobs`);
      else if (localStorage.getItem("activeMenu") == 13)
        this.$router.push(`/procurements`);
      else if (localStorage.getItem("activeMenu") == 13)
        this.$router.push(`/sales`);
      else this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.job-detail-profile-card {
  --profile-border: #e1e7f0;
  --profile-bg: #f8fafc;
  --profile-ink: #172033;
  --profile-muted: #667085;
  --profile-orange: #f58220;
  --profile-orange-dark: #a85510;
}

.job-profile-shell {
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.job-profile-actions {
  align-items: center;
  background: #ffffff !important;
  border-bottom: 1px solid var(--profile-border);
  display: flex;
  justify-content: space-between;
  min-height: 68px;
  padding: 14px 18px !important;
}

.job-profile-actions__title span,
.job-info-panel .subheading.muted {
  color: var(--profile-muted) !important;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}

.job-profile-actions__title strong {
  color: var(--profile-ink);
  display: block;
  font-size: 18px;
  font-weight: 900;
  line-height: 1.25;
  margin-top: 4px;
  overflow-wrap: anywhere;
}

.job-profile-actions__tools {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.job-profile-action-item,
.job-profile-actions__tools .messagebtn {
  display: inline-block;
  flex: 0 0 auto;
  margin: 0 !important;
  max-width: max-content;
  position: static !important;
}

.job-profile-actions__tools .messagebtn,
.job-profile-actions__tools .commentbtn {
  left: auto !important;
  margin: 0 !important;
  position: static !important;
  right: auto !important;
  top: auto !important;
}

.job-profile-actions__tools > .v-btn,
.job-profile-actions__tools > .job-profile-action-item > .v-btn,
.job-profile-actions__tools > .job-profile-action-item > .messagebtn > .v-btn,
.job-profile-actions__tools > .messagebtn > .v-btn,
.job-profile-actions__tools > .job-profile-action-item > .commentbtn {
  background: #ffffff !important;
  border: 1px solid var(--profile-border) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  color: var(--profile-orange-dark) !important;
  height: 36px !important;
  margin: 0;
  min-width: 36px !important;
  padding: 0 12px !important;
  position: static !important;
  right: auto !important;
  top: auto !important;
  width: auto !important;
}

.job-profile-body {
  background: #f4f6fa;
  display: grid;
  gap: 14px;
  padding: 16px !important;
}

.job-info-panel {
  background: #ffffff !important;
  border: 1px solid var(--profile-border) !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 22px rgba(23, 32, 51, 0.05) !important;
  margin: 0 !important;
  padding: 16px;
}

.job-info-panel > .layout:first-child {
  align-items: center;
  border-bottom: 1px solid var(--profile-border);
  margin: -2px 0 14px !important;
  min-height: 42px;
  padding-bottom: 10px;
}

.job-info-panel > .layout:first-child .heading {
  color: var(--profile-ink);
  font-size: 16px !important;
  font-weight: 900;
  padding-bottom: 0 !important;
  white-space: nowrap;
}

.job-info-panel > .layout:first-child .v-divider {
  border-color: var(--profile-border) !important;
}

.job-info-panel > .layout:not(:first-child) {
  display: grid !important;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding-bottom: 0 !important;
}

.job-info-panel > .layout:not(:first-child) > .flex,
.job-info-panel .v-form > .layout > .flex {
  background: var(--profile-bg);
  border: 1px solid #ebeff5;
  border-radius: 10px;
  flex-basis: auto !important;
  max-width: none !important;
  min-height: 78px;
  padding: 13px !important;
  width: auto !important;
}

.job-info-panel .heading {
  color: var(--profile-ink);
  font-size: 13px;
  font-weight: 900;
  line-height: 1.35;
  margin-top: 6px;
  overflow-wrap: anywhere;
  word-break: normal;
}

.job-info-panel .heading[style*="color: red"],
.job-info-panel .heading[style*="color: blue"] {
  color: var(--profile-orange-dark) !important;
}

.job-info-panel .v-input {
  margin-top: 0;
  padding-top: 0;
}

.job-info-panel .v-input input,
.job-info-panel .v-select__selection,
.job-info-panel .v-label {
  font-size: 13px;
  font-weight: 800;
}

.job-info-panel .track-ass-btn,
.job-info-panel .orange-button,
.job-info-panel button {
  background: var(--profile-orange) !important;
  border: 0;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-size: 12px;
  font-weight: 900;
  min-height: 34px;
  padding: 8px 12px;
}

.job-info-panel .v-btn {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: none;
}

.job-info-panel .dropdown-width {
  width: 100%;
}

@media (max-width: 1180px) {
  .job-info-panel > .layout:not(:first-child) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.job-detail-profile-card .job-profile-actions {
  min-height: 54px;
  padding: 10px 14px !important;
}

.job-detail-profile-card .job-profile-actions__title strong {
  font-size: 16px;
  margin-top: 2px;
}

.job-detail-profile-card .job-profile-body {
  gap: 10px;
  padding: 10px !important;
}

.job-detail-profile-card .job-info-panel {
  border-radius: 10px !important;
  padding: 12px;
}

.job-detail-profile-card .job-info-panel > .layout:first-child {
  margin-bottom: 10px !important;
  min-height: 34px;
  padding-bottom: 8px;
}

.job-detail-profile-card .job-info-panel > .layout:first-child .heading {
  font-size: 15px !important;
}

.job-detail-profile-card .job-info-panel > .layout:not(:first-child) {
  gap: 8px;
}

.job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.job-detail-profile-card .job-info-panel .v-form > .layout > .flex {
  border-radius: 8px;
  min-height: 58px;
  padding: 10px !important;
}

.job-detail-profile-card .job-info-panel .heading {
  font-size: 12px;
  margin-top: 4px;
}

.job-profile-shell {
  background: #ffffff !important;
}

.job-profile-actions {
  min-height: 44px !important;
  padding: 8px 12px !important;
}

.job-profile-actions__title strong {
  font-size: 15px;
  margin-top: 1px;
}

.job-profile-actions__tools {
  gap: 6px;
}

.job-profile-actions__tools > .v-btn,
.job-profile-actions__tools > .job-profile-action-item > .v-btn,
.job-profile-actions__tools > .job-profile-action-item > .messagebtn > .v-btn,
.job-profile-actions__tools > .messagebtn > .v-btn,
.job-profile-actions__tools > .job-profile-action-item > .commentbtn {
  height: 30px !important;
  min-height: 30px !important;
  min-width: 30px !important;
  padding: 0 10px !important;
}

.job-profile-body {
  background: #ffffff;
  gap: 0;
  padding: 0 !important;
}

.job-info-panel {
  border: 0 !important;
  border-radius: 0 !important;
  border-top: 1px solid var(--profile-border) !important;
  box-shadow: none !important;
  padding: 9px 12px 10px;
}

.job-info-panel:first-child {
  border-top: 0 !important;
}

.job-info-panel > .layout:first-child {
  margin: 0 0 6px !important;
  min-height: 28px;
  padding-bottom: 5px;
}

.job-info-panel > .layout:first-child .heading {
  font-size: 14px !important;
}

.job-info-panel > .layout:not(:first-child) {
  gap: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.job-info-panel > .layout:not(:first-child) > .flex,
.job-info-panel .v-form > .layout > .flex {
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #eef2f7;
  border-radius: 0;
  border-right: 1px solid #eef2f7;
  min-height: 46px;
  padding: 7px 10px !important;
}

.job-info-panel .subheading.muted {
  font-size: 10px;
  line-height: 1.2;
}

.job-info-panel .heading {
  font-size: 12px;
  line-height: 1.28;
  margin-top: 3px;
}

.job-info-panel .v-text-field > .v-input__control > .v-input__slot,
.job-info-panel .v-select > .v-input__control > .v-input__slot {
  min-height: 34px;
}

.job-info-panel .track-ass-btn,
.job-info-panel .orange-button,
.job-info-panel button {
  min-height: 30px;
  padding: 6px 10px;
}

.job-detail-profile-card {
  background: #ffffff;
}

.job-detail-profile-card .job-profile-shell,
.job-detail-profile-card .job-profile-body,
.job-detail-profile-card .job-info-panel {
  background: transparent !important;
  box-shadow: none !important;
}

.job-detail-profile-card .job-profile-actions {
  border-bottom: 1px solid #e7ebf2;
  min-height: 38px !important;
  padding: 6px 10px !important;
}

.job-detail-profile-card .job-profile-actions__title span {
  font-size: 9px;
}

.job-detail-profile-card .job-profile-actions__title strong {
  font-size: 14px;
  line-height: 1.15;
}

.job-detail-profile-card .job-profile-body {
  padding: 0 !important;
}

.job-detail-profile-card .job-info-panel {
  border: 0 !important;
  border-radius: 0 !important;
  border-top: 1px solid #e7ebf2 !important;
  margin: 0 !important;
  padding: 6px 10px 8px !important;
}

.job-detail-profile-card .job-info-panel:first-child {
  border-top: 0 !important;
}

.job-detail-profile-card .job-info-panel > .layout:first-child {
  border-bottom: 0;
  margin: 0 !important;
  min-height: 22px;
  padding-bottom: 2px;
}

.job-detail-profile-card .job-info-panel > .layout:first-child .heading {
  color: #111827;
  font-size: 12px !important;
  line-height: 1.1;
}

.job-detail-profile-card .job-info-panel > .layout:first-child .v-divider {
  margin: 9px 0 !important;
}

.job-detail-profile-card .job-info-panel > .layout:not(:first-child) {
  border-top: 1px solid #eef1f6;
  display: grid !important;
  gap: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 0 !important;
}

.job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.job-detail-profile-card .job-info-panel .v-form > .layout > .flex {
  align-items: flex-start;
  background: transparent !important;
  border: 0;
  border-bottom: 1px solid #eef1f6;
  border-radius: 0;
  border-right: 1px solid #eef1f6;
  display: grid !important;
  flex-basis: auto !important;
  gap: 3px 8px;
  grid-template-columns: minmax(92px, 0.44fr) minmax(0, 1fr);
  max-width: none !important;
  min-height: 30px;
  padding: 5px 8px !important;
  width: auto !important;
}

.job-detail-profile-card .job-info-panel .subheading.muted {
  align-self: start;
  color: #7a8494 !important;
  font-size: 9px !important;
  line-height: 1.2;
  padding-top: 1px;
}

.job-detail-profile-card .job-info-panel .heading {
  color: #111827;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
  margin: 0;
}

.job-detail-profile-card .job-info-panel .v-input,
.job-detail-profile-card .job-info-panel .v-select,
.job-detail-profile-card .job-info-panel .v-radio-group {
  grid-column: 1 / -1;
  margin: 0;
  padding: 0;
}

.job-detail-profile-card .job-info-panel .v-text-field > .v-input__control > .v-input__slot,
.job-detail-profile-card .job-info-panel .v-select > .v-input__control > .v-input__slot {
  min-height: 28px;
}

.job-detail-profile-card .job-info-panel .track-ass-btn,
.job-detail-profile-card .job-info-panel .orange-button,
.job-detail-profile-card .job-info-panel button,
.job-detail-profile-card .job-info-panel .v-btn {
  border-radius: 5px !important;
  font-size: 11px;
  min-height: 26px;
  padding: 4px 8px !important;
}

.job-info-panel--billing,
.job-info-panel--commercial {
  --profile-section-accent: #f58220;
}

.job-detail-profile-card .payer-strip {
  align-items: stretch;
  display: grid;
  gap: 0;
  grid-column: 1 / -1;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  width: 100%;
}

.job-detail-profile-card .payer-strip__item {
  align-content: start;
  border-right: 1px solid #eef1f6;
  display: grid;
  gap: 3px;
  min-height: 30px;
  padding-right: 8px;
}

.job-detail-profile-card .payer-strip__item:last-child {
  border-right: 0;
  padding-left: 8px;
  padding-right: 0;
}

.job-detail-profile-card .payer-strip__item span {
  align-items: center;
  color: #7a8494;
  display: inline-flex;
  font-size: 9px;
  font-weight: 900;
  gap: 4px;
  line-height: 1.15;
  text-transform: uppercase;
}

.job-detail-profile-card .payer-strip__item .v-icon {
  color: #98a2b3 !important;
  font-size: 13px !important;
}

.job-detail-profile-card .payer-strip__item strong {
  color: #111827;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.job-detail-profile-card .payer-strip__radio {
  grid-column: auto;
}

.job-detail-profile-card .payer-strip__radio .v-input__control {
  min-height: 0;
}

.job-detail-profile-card .payer-strip__radio .v-input__slot {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 14px;
  margin: 0;
}

.job-detail-profile-card .payer-strip__radio .v-radio {
  box-sizing: border-box;
  flex: 0 0 auto;
  margin: 0;
  max-width: 11.5rem;
  min-height: 2rem;
  padding: 0.3125rem 0.75rem;
  width: 100%;
}

.job-detail-profile-card .payer-strip__radio .v-label {
  color: #111827;
  font-size: 11px;
  font-weight: 900;
}

.job-detail-profile-card {
  border: 1px solid rgba(226, 232, 240, 0.96);
  border-radius: 10px;
  overflow: hidden;
}

.job-detail-profile-card .job-profile-actions {
  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%) !important;
  box-shadow: 0 1px 0 rgba(226, 232, 240, 0.76);
  gap: 12px;
}

.job-detail-profile-card .job-profile-actions__tools,
.job-detail-profile-card .job-profile-action-item,
.job-detail-profile-card .job-profile-action-item > div,
.job-detail-profile-card .job-profile-actions__tools .messagebtn {
  align-items: center;
  display: inline-flex;
}

.job-detail-profile-card .job-profile-action-item > div,
.job-detail-profile-card .job-profile-actions__tools .messagebtn {
  margin: 0 !important;
}

.job-detail-profile-card .job-profile-actions__tools .commentbtn,
.job-detail-profile-card .job-profile-action-item--change .commentbtn,
.job-detail-profile-card .job-profile-action-item--message .v-btn,
.job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn {
  align-items: center !important;
  background: #fff7ed !important;
  border: 1px solid #fed7aa !important;
  border-radius: 7px !important;
  box-shadow: none !important;
  color: #a85510 !important;
  display: inline-flex !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  height: 30px !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: 30px !important;
  min-width: 30px !important;
  padding: 0 9px !important;
  position: static !important;
  right: auto !important;
  text-transform: none !important;
  top: auto !important;
  transition: background-color 0.16s ease, border-color 0.16s ease,
    color 0.16s ease, transform 0.16s ease;
  width: auto !important;
}

.job-detail-profile-card .job-profile-action-item--change,
.job-detail-profile-card .job-profile-action-item--message,
.job-detail-profile-card .job-profile-action-item--comments {
  height: 30px;
}

.job-detail-profile-card .job-profile-action-item--message .messagebtn,
.job-detail-profile-card .job-profile-action-item--message .v-btn {
  height: 30px !important;
  vertical-align: top;
}

.job-detail-profile-card .job-profile-action-item--message .v-btn__content {
  align-items: center;
  display: inline-flex;
  height: 100%;
  line-height: 1;
  white-space: nowrap;
}

.job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn {
  padding: 0 !important;
  width: 30px !important;
}

.job-detail-profile-card .job-profile-action-item--change .commentbtn:hover,
.job-detail-profile-card .job-profile-action-item--message .v-btn:hover,
.job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn:hover {
  background: #ffedd5 !important;
  border-color: #fdba74 !important;
  color: #8a420b !important;
  transform: translateY(-1px);
}

.job-detail-profile-card .job-profile-action-item--change .commentbtn .v-btn__content,
.job-detail-profile-card .job-profile-action-item--message .v-btn__content {
  align-items: center;
  display: inline-flex;
  gap: 5px;
}

.job-detail-profile-card .job-profile-action-item--change .commentbtn .v-btn__content::before,
.job-detail-profile-card .job-profile-action-item--message .v-btn__content::before {
  direction: ltr;
  display: inline-block;
  font-family: "Material Icons";
  font-size: 15px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-height: 1;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
}

.job-detail-profile-card .job-profile-action-item--change .commentbtn .v-btn__content::before {
  content: "swap_horiz";
}

.job-detail-profile-card .job-profile-action-item--message .v-btn__content::before {
  content: "sms";
}

.job-detail-profile-card .job-profile-action-item--message .v-btn--disabled {
  background: #f2f4f7 !important;
  border-color: #e4e7ec !important;
  color: #98a2b3 !important;
}

.job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn .v-icon {
  color: currentColor !important;
  font-size: 17px !important;
}

.job-detail-profile-card .job-info-panel {
  transition: none !important;
}

.job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex:hover,
.job-detail-profile-card .job-info-panel .v-form > .layout > .flex:hover {
  background: transparent !important;
}

.theme--dark .job-detail-profile-card,
.application--dark .job-detail-profile-card {
  --profile-border: #2b3545;
  --profile-bg: #111827;
  --profile-ink: #f8fafc;
  --profile-muted: #aab4c3;
  background: #111827;
  border-color: #2b3545;
}

.theme--dark .job-detail-profile-card .job-profile-actions,
.application--dark .job-detail-profile-card .job-profile-actions {
  background: linear-gradient(180deg, #172033 0%, #121a2a 100%) !important;
  border-color: #2b3545;
  box-shadow: 0 1px 0 rgba(43, 53, 69, 0.9);
}

.theme--dark .job-detail-profile-card .job-profile-actions__title strong,
.theme--dark .job-detail-profile-card .job-info-panel .heading,
.theme--dark .job-detail-profile-card .payer-strip__item strong,
.theme--dark .job-detail-profile-card .payer-strip__radio .v-label,
.application--dark .job-detail-profile-card .job-profile-actions__title strong,
.application--dark .job-detail-profile-card .job-info-panel .heading,
.application--dark .job-detail-profile-card .payer-strip__item strong,
.application--dark .job-detail-profile-card .payer-strip__radio .v-label {
  color: #f8fafc !important;
}

.theme--dark .job-detail-profile-card .job-info-panel,
.application--dark .job-detail-profile-card .job-info-panel {
  background: #111827 !important;
  border-color: #2b3545 !important;
}

.theme--dark .job-detail-profile-card .job-info-panel > .layout:not(:first-child),
.theme--dark .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.theme--dark .job-detail-profile-card .job-info-panel .v-form > .layout > .flex,
.theme--dark .job-detail-profile-card .payer-strip__item,
.application--dark .job-detail-profile-card .job-info-panel > .layout:not(:first-child),
.application--dark .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.application--dark .job-detail-profile-card .job-info-panel .v-form > .layout > .flex,
.application--dark .job-detail-profile-card .payer-strip__item {
  border-color: #273244 !important;
}

.theme--dark .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex:hover,
.theme--dark .job-detail-profile-card .job-info-panel .v-form > .layout > .flex:hover,
.application--dark .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex:hover,
.application--dark .job-detail-profile-card .job-info-panel .v-form > .layout > .flex:hover {
  background: #172033 !important;
}

.theme--dark .job-detail-profile-card .job-profile-action-item--change .commentbtn,
.theme--dark .job-detail-profile-card .job-profile-action-item--message .v-btn,
.theme--dark .job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn,
.application--dark .job-detail-profile-card .job-profile-action-item--change .commentbtn,
.application--dark .job-detail-profile-card .job-profile-action-item--message .v-btn,
.application--dark .job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn {
  background: rgba(245, 130, 32, 0.16) !important;
  border-color: rgba(245, 130, 32, 0.34) !important;
  color: #fdba74 !important;
}

@media (max-width: 760px) {
  .job-profile-actions {
    align-items: flex-start;
    flex-direction: column;
  }

  .job-profile-actions__tools {
    justify-content: flex-start;
  }

  .job-info-panel > .layout:not(:first-child) {
    grid-template-columns: 1fr;
  }

  .job-detail-profile-card .job-profile-actions__tools {
    width: 100%;
  }

  .job-detail-profile-card .job-profile-action-item--change .commentbtn,
  .job-detail-profile-card .job-profile-action-item--message .v-btn {
    min-width: 0 !important;
  }
}

.job-dossier--modern .job-detail-profile-card {
  --profile-border: #e7ebf2;
  --profile-cell: #fbfcff;
  --profile-cell-hover: #fffaf5;
  background: transparent;
  border: 0;
  border-radius: 0;
  overflow: visible;
}

.job-dossier--modern .job-detail-profile-card .job-profile-shell {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  overflow: visible;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid var(--profile-border) !important;
  border-radius: 8px !important;
  box-shadow: 0 14px 30px rgba(17, 24, 39, 0.05) !important;
  display: flex;
  gap: 1rem;
  margin: 0 0 0.875rem !important;
  min-height: 5.5rem !important;
  padding: 1rem 1.125rem !important;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__title {
  align-items: center;
  display: grid;
  flex: 1 1 auto;
  gap: 0;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__title::before {
  background: #fff2e5;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  content: "";
  display: none;
  grid-row: 1 / span 2;
  height: 2.5rem;
  width: 2.5rem;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__title span {
  color: #7a8494 !important;
  font-size: 0.6875rem;
  line-height: 1.2;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__title strong {
  color: #111827;
  font-size: 1.375rem;
  line-height: 1.15;
  margin: 0.125rem 0 0;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__tools {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.job-dossier--modern .job-detail-profile-card .job-profile-action-item,
.job-dossier--modern .job-detail-profile-card .job-profile-action-item > div,
.job-dossier--modern .job-detail-profile-card .job-profile-actions__tools .messagebtn {
  align-items: center;
  display: inline-flex;
  height: 2.25rem;
  margin: 0 !important;
  max-width: none;
  position: static !important;
}

.job-dossier--modern .job-detail-profile-card .job-profile-action-item--change .commentbtn,
.job-dossier--modern .job-detail-profile-card .job-profile-action-item--message .v-btn,
.job-dossier--modern .job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn {
  align-items: center !important;
  border-radius: 7px !important;
  box-shadow: none !important;
  display: inline-flex !important;
  font-size: 0.75rem !important;
  font-weight: 900 !important;
  height: 2.25rem !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: 2.25rem !important;
  min-width: 2.25rem !important;
  padding: 0 0.75rem !important;
  position: static !important;
  right: auto !important;
  text-transform: none !important;
  top: auto !important;
  width: auto !important;
}

.job-dossier--modern .job-detail-profile-card .job-profile-action-item--change .commentbtn,
.job-dossier--modern .job-detail-profile-card .job-profile-action-item--message .v-btn {
  background: #ffffff !important;
  border: 1px solid var(--profile-border) !important;
  color: #344054 !important;
}

.job-dossier--modern .job-detail-profile-card .job-profile-action-item--comments .oms-comment-plus-btn {
  background: #f58220 !important;
  border: 1px solid #f58220 !important;
  color: #ffffff !important;
}

.job-dossier--modern .job-detail-profile-card .job-profile-body {
  background: transparent !important;
  display: grid;
  gap: 0.875rem;
  grid-template-columns: repeat(2, minmax(18rem, 1fr));
  padding: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel {
  background: #ffffff !important;
  border: 1px solid var(--profile-border) !important;
  border-radius: 8px !important;
  box-shadow: 0 14px 30px rgba(17, 24, 39, 0.05) !important;
  margin: 0 !important;
  min-width: 0;
  overflow: hidden;
  padding: 0.875rem 1rem 1rem !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel--commercial {
  grid-column: 1 / -1;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:first-child {
  align-items: center;
  border-bottom: 1px solid var(--profile-border) !important;
  display: flex !important;
  margin: 0 0 0.75rem !important;
  min-height: 0;
  padding: 0 0 0.625rem !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:first-child > .flex:first-child {
  flex: 0 1 auto !important;
  max-width: none !important;
  padding: 0 !important;
  width: auto !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:first-child > .flex:last-child {
  flex: 1 1 auto !important;
  max-width: none !important;
  padding: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:first-child .heading {
  color: #111827;
  font-size: 0.9375rem !important;
  line-height: 1.2;
  padding: 0 !important;
  white-space: nowrap;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:first-child .v-divider {
  display: none;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child),
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout {
  border: 0 !important;
  display: grid !important;
  gap: 0.625rem 0.75rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel--commercial > .layout:not(:first-child),
.job-dossier--modern .job-detail-profile-card .job-info-panel--commercial .v-form > .layout {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) + .layout,
.job-dossier--modern .job-detail-profile-card .job-info-panel > .v-form + .layout {
  margin-top: 0.625rem !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout > .flex {
  align-items: flex-start;
  background: var(--profile-cell) !important;
  border: 1px solid #edf1f6 !important;
  border-radius: 8px !important;
  display: block !important;
  flex-basis: auto !important;
  max-width: none !important;
  min-height: 4rem;
  padding: 0.625rem 0.75rem !important;
  transition: none !important;
  width: auto !important;
}

.job-dossier--modern
  .job-detail-profile-card
  .job-info-panel--identity
  > .layout:not(:first-child)
  > .flex {
  grid-template-columns: minmax(6.5rem, 0.34fr) minmax(0, 1fr);
}

.job-dossier--modern
  .job-detail-profile-card
  .job-info-panel--identity
  > .layout:not(:first-child)
  > .flex
  .heading {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex:hover,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout > .flex:hover {
  background: var(--profile-cell) !important;
  border-color: #edf1f6 !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout > .flex {
  cursor: default !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel input,
.job-dossier--modern .job-detail-profile-card .job-info-panel textarea {
  cursor: text !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input--is-disabled,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input--is-disabled * {
  cursor: default !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel,
.job-dossier--modern .job-detail-profile-card .job-info-panel .heading,
.job-dossier--modern .job-detail-profile-card .job-info-panel .subheading,
.job-dossier--modern .job-detail-profile-card .job-info-panel .muted,
.job-dossier--modern .job-detail-profile-card .payer-strip,
.job-dossier--modern .job-detail-profile-card .payer-strip * {
  cursor: default !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input__slot,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input__control {
  transition: none !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input:not(.v-input--is-disabled) input,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input:not(.v-input--is-disabled) textarea {
  cursor: text !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-select:not(.v-input--is-disabled),
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-select:not(.v-input--is-disabled) *,
.job-dossier--modern .job-detail-profile-card .payer-strip__radio:not(.v-input--is-disabled) .v-radio,
.job-dossier--modern .job-detail-profile-card .payer-strip__radio:not(.v-input--is-disabled) .v-label,
.job-dossier--modern .job-detail-profile-card .payer-strip__radio:not(.v-input--is-disabled) .v-input--selection-controls__input,
.job-dossier--modern .job-detail-profile-card .job-info-panel button:not([disabled]),
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-btn:not(.v-btn--disabled) {
  cursor: pointer !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .subheading.muted,
.job-dossier--modern .job-detail-profile-card .payer-strip__item span {
  color: #7a8494 !important;
  display: block;
  font-size: 0.65625rem !important;
  font-weight: 900;
  line-height: 1.2;
  text-transform: uppercase;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .heading,
.job-dossier--modern .job-detail-profile-card .payer-strip__item strong {
  color: #111827;
  font-size: 0.8125rem;
  font-weight: 900;
  hyphens: none;
  line-height: 1.3;
  margin-top: 0.25rem;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: normal;
  text-wrap: pretty;
  white-space: normal;
  word-break: normal;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .heading[style*="color: red"] {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  caret-color: transparent !important;
  color: #c0560d !important;
  cursor: default !important;
  display: inline-flex;
  font-size: 0.75rem;
  line-height: 1;
  margin-top: 0.375rem;
  padding: 0.3125rem 0.5rem;
  pointer-events: auto !important;
  transition: none !important;
  user-select: none !important;
}

.job-dossier .job-detail-profile-card .job-profile-status-cell,
.job-dossier .job-detail-profile-card .job-profile-status-cell *,
.job-dossier .job-detail-profile-card .job-profile-status-value,
.job-dossier .job-detail-profile-card .job-profile-status-value * {
  caret-color: transparent !important;
  cursor: default !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .heading[style*="color: blue"] {
  color: #111827 !important;
}

.job-dossier--modern .job-detail-profile-card .payer-strip {
  background: transparent !important;
  border: 0 !important;
  display: grid;
  gap: 0.5rem;
  grid-template-columns: 1fr;
  padding: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .payer-strip__item {
  background: transparent !important;
  border: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 0;
  padding: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .payer-strip__item > span,
.job-dossier--modern .job-detail-profile-card .payer-strip__item > strong {
  align-self: stretch;
  display: block;
  text-align: left !important;
  width: 100%;
}

.job-dossier--modern .job-detail-profile-card .payer-strip__item--entity {
  margin-top: 0.75rem;
}

.job-dossier--modern
  .job-detail-profile-card
  .invoicing-branch-field {
  align-items: center !important;
  display: grid !important;
  gap: 0.75rem;
  grid-template-columns: minmax(6.5rem, 0.45fr) minmax(0, 1fr);
}

.job-dossier--modern
  .job-detail-profile-card
  .invoicing-branch-field
  > .subheading {
  align-self: center;
  text-align: left;
}

.job-dossier--modern
  .job-detail-profile-card
  .invoicing-branch-field
  > .heading {
  align-self: center;
  justify-self: center;
  text-align: center !important;
}

.job-dossier--modern
  .job-detail-profile-card
  .payer-strip__item--entity
  > strong {
  margin-top: 0.375rem !important;
}

.job-dossier--modern .job-detail-profile-card .payer-strip__radio,
.job-dossier--modern .job-detail-profile-card .payer-strip__radio .v-input__control,
.job-dossier--modern .job-detail-profile-card .payer-strip__radio .v-input__slot {
  margin: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .payer-strip__radio .v-input__slot {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.625rem !important;
}

.job-dossier--modern .job-detail-profile-card .payer-strip__radio .v-radio {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  flex: 0 0 auto;
  margin: 0 !important;
  max-width: 11.5rem;
  min-height: 2rem;
  padding: 0;
  width: 100%;
}

.job-dossier--modern .job-detail-profile-card .payer-strip__radio .v-label {
  color: #111827;
  font-size: 0.75rem;
  font-weight: 900;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-select,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-radio-group {
  margin-top: 0.25rem;
  padding-top: 0;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-text-field > .v-input__control > .v-input__slot,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-select > .v-input__control > .v-input__slot {
  background: #ffffff;
  border: 1px solid var(--profile-border);
  border-radius: 7px;
  min-height: 2.25rem;
  padding: 0 0.625rem;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-text-field > .v-input__control > .v-input__slot::before,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-text-field > .v-input__control > .v-input__slot::after,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-select > .v-input__control > .v-input__slot::before,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-select > .v-input__control > .v-input__slot::after {
  display: none;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .track-ass-btn,
.job-dossier--modern .job-detail-profile-card .job-info-panel .orange-button,
.job-dossier--modern .job-detail-profile-card .job-info-panel button,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-btn {
  border-radius: 7px !important;
  box-shadow: none !important;
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0;
  min-height: 2rem;
  padding: 0.375rem 0.625rem !important;
  text-transform: none;
}

@media (max-width: 1180px) {
  .job-dossier--modern .job-detail-profile-card .job-profile-body {
    grid-template-columns: 1fr;
  }

  .job-dossier--modern .job-detail-profile-card .job-info-panel--commercial {
    grid-column: auto;
  }
}

@media (max-width: 760px) {
  .job-dossier--modern .job-detail-profile-card .job-profile-actions {
    align-items: flex-start;
    flex-direction: column;
    min-height: 0 !important;
  }

  .job-dossier--modern .job-detail-profile-card .job-profile-actions__tools {
    justify-content: flex-start;
    width: 100%;
  }

  .job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child),
  .job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout,
  .job-dossier--modern .job-detail-profile-card .job-info-panel--commercial > .layout:not(:first-child),
  .job-dossier--modern .job-detail-profile-card .job-info-panel--commercial .v-form > .layout {
    grid-template-columns: 1fr;
  }
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions,
.job-dossier--modern .job-detail-profile-card .job-info-panel {
  min-width: 0;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions {
  flex-wrap: wrap;
  min-height: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__title {
  flex: 1 1 17rem;
  max-width: 100%;
  min-width: 0;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__title strong {
  overflow-wrap: anywhere;
  white-space: normal !important;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__tools {
  flex: 1 1 18rem;
  min-width: 0;
}

.job-dossier--modern .job-detail-profile-card .job-profile-actions__tools .v-btn,
.job-dossier--modern .job-detail-profile-card .job-profile-actions__tools button,
.job-dossier--modern .job-detail-profile-card .job-profile-actions__tools .commentbtn {
  max-width: 100%;
  overflow-wrap: anywhere;
  white-space: normal !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child),
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout {
  gap: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout > .flex {
  align-items: center;
  border-radius: 0 !important;
  display: grid !important;
  gap: 0.75rem;
  grid-template-columns: minmax(7.75rem, 0.42fr) minmax(0, 1fr);
  min-height: 3.25rem;
  min-width: 0;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel--commercial > .layout:not(:first-child) > .flex,
.job-dossier--modern .job-detail-profile-card .job-info-panel--commercial .v-form > .layout > .flex {
  border-right: 1px solid #eef1f6 !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel--commercial > .layout:not(:first-child) > .flex:nth-child(3n),
.job-dossier--modern .job-detail-profile-card .job-info-panel--commercial .v-form > .layout > .flex:nth-child(3n) {
  border-right: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .subheading.muted,
.job-dossier--modern .job-detail-profile-card .job-info-panel .muted.caption {
  margin: 0 !important;
  min-width: 0;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .heading,
.job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex > div:not(.subheading):not(.muted),
.job-dossier--modern .job-detail-profile-card .payer-strip__item strong {
  align-self: center;
  hyphens: none;
  justify-self: stretch;
  margin-top: 0;
  min-width: 0;
  overflow-wrap: normal;
  text-align: center;
  text-wrap: pretty;
  white-space: normal !important;
  word-break: normal;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .job-field-value--reference {
  font-size: 0.75rem !important;
  white-space: nowrap !important;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-select,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-radio-group {
  grid-column: 1 / -1;
  margin: 0 !important;
  min-width: 0;
  padding: 0 !important;
  text-align: left;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel .v-input__slot {
  margin: 0 !important;
}

.job-dossier--modern .job-detail-profile-card .payer-strip {
  grid-column: 1 / -1;
  min-width: 0;
}

.job-dossier--modern .job-detail-profile-card .job-info-panel button,
.job-dossier--modern .job-detail-profile-card .job-info-panel .v-btn {
  align-items: center !important;
  display: inline-flex !important;
  justify-content: center !important;
  line-height: 1.15 !important;
  max-width: 100%;
  overflow-wrap: anywhere;
  text-align: center !important;
  white-space: normal !important;
  width: auto !important;
}

/*
 * Treat read-only job information as one stable hover surface. Vuetify's
 * nested text nodes otherwise alternate between text/default cursor targets
 * as the pointer crosses a label or value.
 */
.job-dossier .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
.job-dossier .job-detail-profile-card .job-info-panel .v-form > .layout > .flex {
  caret-color: transparent !important;
  cursor: default !important;
  filter: none !important;
  transform: none !important;
  transition: none !important;
}

.job-dossier .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex:hover,
.job-dossier .job-detail-profile-card .job-info-panel .v-form > .layout > .flex:hover {
  filter: none !important;
  transform: none !important;
  transition: none !important;
}

.job-dossier .job-detail-profile-card .job-info-panel .heading,
.job-dossier .job-detail-profile-card .job-info-panel .heading *,
.job-dossier .job-detail-profile-card .job-info-panel .subheading,
.job-dossier .job-detail-profile-card .job-info-panel .subheading *,
.job-dossier .job-detail-profile-card .job-info-panel .muted,
.job-dossier .job-detail-profile-card .job-info-panel .muted * {
  caret-color: transparent !important;
  cursor: default !important;
  pointer-events: auto !important;
  user-select: text !important;
}

.job-dossier .job-detail-profile-card .job-info-panel :is(
  input,
  textarea,
  select,
  button,
  a,
  .v-btn,
  .v-select,
  .v-radio,
  .v-label,
  .v-input--selection-controls__input
) {
  pointer-events: auto !important;
}

/* Keep header actions inside their own hit areas and remove icon hover jitter. */
.job-dossier .job-detail-profile-card .job-profile-actions {
  isolation: isolate;
  position: relative;
  z-index: 2;
}

.job-dossier .job-detail-profile-card .job-profile-actions__tools,
.job-dossier .job-detail-profile-card .job-profile-action-item,
.job-dossier .job-detail-profile-card .job-profile-action-item > div,
.job-dossier
  .job-detail-profile-card
  .job-profile-action-item
  .popup-action-inline {
  inset: auto !important;
  max-width: max-content !important;
  position: static !important;
  transform: none !important;
}

.job-dossier .job-detail-profile-card .job-profile-actions__tools .v-btn,
.job-dossier .job-detail-profile-card .job-profile-actions__tools button,
.job-dossier .job-detail-profile-card .job-profile-actions__tools .v-icon,
.job-dossier .job-detail-profile-card .job-profile-actions__tools .v-btn__content,
.job-dossier .job-detail-profile-card .job-info-panel .v-icon {
  animation: none !important;
  backface-visibility: hidden;
  transform: none !important;
  transition: none !important;
}

.job-dossier
  .job-detail-profile-card
  .job-profile-actions__tools
  button:hover,
.job-dossier
  .job-detail-profile-card
  .job-profile-actions__tools
  .v-btn:hover {
  transform: none !important;
}

.job-dossier .job-detail-profile-card .job-work-order-cell,
.job-dossier .job-detail-profile-card .job-work-order-cell * {
  cursor: default !important;
}

.job-dossier .job-detail-profile-card .job-work-order-cell button,
.job-dossier .job-detail-profile-card .job-work-order-cell .v-btn {
  cursor: pointer !important;
}

@media (max-width: 1180px) {
  .job-dossier--modern .job-detail-profile-card .job-info-panel--commercial > .layout:not(:first-child) > .flex,
  .job-dossier--modern .job-detail-profile-card .job-info-panel--commercial .v-form > .layout > .flex {
    border-right: 0 !important;
  }
}

@media (max-width: 760px) {
  .job-dossier--modern .job-detail-profile-card .job-profile-actions__tools {
    flex: 1 1 auto;
  }

  .job-dossier--modern .job-detail-profile-card .job-info-panel {
    padding: 0.875rem !important;
  }

  .job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex,
  .job-dossier--modern .job-detail-profile-card .job-info-panel .v-form > .layout > .flex {
    gap: 0.25rem;
    grid-template-columns: 1fr;
    min-height: 0;
    padding: 0.625rem 0 !important;
  }

  .job-dossier--modern .job-detail-profile-card .job-info-panel .heading,
  .job-dossier--modern .job-detail-profile-card .job-info-panel > .layout:not(:first-child) > .flex > div:not(.subheading):not(.muted),
  .job-dossier--modern .job-detail-profile-card .payer-strip__item strong {
    text-align: left;
  }
}
</style>

<style scoped>
.send-message {
  margin: 0 auto;
}
.status {
  margin: 0 20px;
}
.dropdown-width {
  width: 80%;
}
.location {
  align-self: flex-start;
}
.heading {
  hyphens: none;
  overflow-wrap: normal;
  text-wrap: pretty;
  white-space: normal;
  word-break: normal;
}
.p-r-25 {
  padding-right: 25px;
}
.p-r-25 {
  padding-right: 25px;
}

.track-job-button {
  background-color: #ea7a1c;
  color: #ffffff;
  padding: 10px;
  text-decoration: none;
}
.driverbtn {
  position: absolute;
  right: 270px;
  /*top: 25px;*/
}
.notifybtn {
  position: absolute;
  right: 430px;
  top: 25px;
}
.f-20 {
  font-size: 22px;
  font-weight: bolder;
}
.my-5 {
  margin-top: 22px !important;
}
.spacerclass {
  max-height: 550px !important;
}
.fonthead {
  font-size: 20px;
}
</style>
